import { coerceBooleanProperty } from '@angular/cdk/coercion';
import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Optional, Output, Self } from '@angular/core';
import { ControlValueAccessor, NgControl, ReactiveFormsModule } from '@angular/forms';
import { MatSlideToggleChange, MatSlideToggleModule } from '@angular/material/slide-toggle';

@Component({
  selector: 'cs-switch',
  standalone: true,
  imports: [CommonModule, MatSlideToggleModule, ReactiveFormsModule],
  templateUrl: './cs-switch.component.html',
  styleUrls: ['./cs-switch.component.scss'],
})
export class CSSwitchComponent implements ControlValueAccessor {
  private _disabled: boolean = false;
  private _value: boolean = false;
  private onChange: (value: boolean) => void = () => {};
  private onTouched: () => void = () => {};

  @Input() label: string = '';
  @Input() formControlName: string | null = null;
  @Input()
  get disabled(): boolean {
    return this._disabled;
  }
  set disabled(newValue: unknown) {
    const coercedValue = coerceBooleanProperty(newValue);
    this._disabled = coercedValue;

    // 同步 FormControl 的禁用状态
    if (this.ngControl?.control) {
      this.ngControl.valueAccessor = this;
      coercedValue ? this.ngControl.control.disable() : this.ngControl.control.enable();
    }
  }

  @Input()
  get value() {
    return this._value;
  }
  set value(newValue) {
    this._value = newValue;
  }

  @Output() valueChange = new EventEmitter<boolean>();

  constructor(@Optional() @Self() private ngControl: NgControl) {
    if (this.ngControl !== null) {
      ngControl.valueAccessor = this;
    }
  }

  writeValue(value: boolean): void {
    this._value = value;
  }

  registerOnChange(fn: (value: boolean) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this._disabled = isDisabled;
  }

  onSwitchChange(event: MatSlideToggleChange): void {
    this._value = event.checked;
    this.valueChange.emit(this.value);
    this.onChange(this.value);
    this.onTouched();
  }
}
